import { OptionType } from "../custom-select/Select";
import "./Checkbox.css";

interface checkboxProps {
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  name?: string;
  value?: string | string[];
  data: OptionType[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FC<checkboxProps> = ({
  checked,
  disabled,
  data,
  name,
  value,
  label,
  onChange,
}) => {
  //   console.log("data:", data);
  //   console.log("value:", value);
  return (
    <label className="custom-checkbox" onClick={(e) => e.stopPropagation()}>
      {label && <span>{label}</span>}
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          //console.log("checked:", e.target.checked);
          onChange?.(e);
        }}
      />
      <span className="checkmark"></span>
    </label>
  );
};

export default Checkbox;
